import { render, staticRenderFns } from "./modalKemasan.vue?vue&type=template&id=211d6b4d&"
import script from "./modalKemasan.vue?vue&type=script&lang=js&"
export * from "./modalKemasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports